var path = 'areas/library/lifecycles/views/create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/lifecycles\">Lifecycles</a></li>\r\n    <li><a href=\"#/library/lifecycles/new\">Create New</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <lifecycle-editor></lifecycle-editor> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/views/create.html
// module id = 8119421279316913
// module chunks = 1